module.exports = __webpack_public_path__ + "img/05.6ce61710.png";